import { sdgCompliancesSlice } from './slice'

// Get All
export const { setSdgCompliancesLoading } = sdgCompliancesSlice.actions
export const { setSdgCompliancesList } = sdgCompliancesSlice.actions
export const { resetSdgCompliancesListState } = sdgCompliancesSlice.actions
